import { useEffect, useState } from "react"
import { useNavigate, Link } from "react-router-dom"
import LoginWhatsAppStep1 from "../../components/Auth/LoginWhatsAppStep1"
import LoginWhatsAppStep2 from "../../components/Auth/LoginWhatsAppStep2"
import { useAppDispatch, useAppSelector } from "../../redux/store"
import {
  setError,
  setLoginPhoneStepOne,
} from "../../redux/slices/auth/authSlice"
import { BsFillCaretLeftFill } from "react-icons/bs"
import { useTranslation } from "react-i18next"
import {
  IconAlertCircle,
  IconArrowLeft,
} from "../../components/utils/Icons/CustomIcons"
import Skeleton from "@/components/common/skeleton"
import success from "@/assets/images/welcomenn.svg" // Adjust the path as necessary
import invitesmart from "@/assets/images/invitesmart.svg" // Adjust the path as necessary

const LoginWhatsAppPage = () => {
  const [isLoadingImage, setIsLoadingImage] = useState(true)

  const handleImageLoad = () => {
    setIsLoadingImage(false)
  }
  const { t } = useTranslation()
  const { status, error, phone, accessToken } = useAppSelector(
    (state) => state.auth,
  )

  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const hidePhone = (phone: string | null): string => {
    const visibleNumber = [
      0,
      1,
      phone ? phone.length - 2 : 0,
      phone ? phone.length - 1 : 0,
    ]
    let hidePhone = ""

    if (phone) {
      for (let i = 0; i < phone.length; i++) {
        if (visibleNumber.includes(i)) {
          hidePhone = `${hidePhone}${phone[i]}`
        } else {
          hidePhone = hidePhone + "*"
        }
      }
    }
    return hidePhone
  }

  useEffect(() => {
    if (status === "LOGIN-SUCCESS") {
      navigate("/")
    }

    return () => {
      if (error) {
        dispatch(setError(""))
      }
    }
  }, [status])

  useEffect(() => {
    if (accessToken) {
      navigate("/")
    }

    return () => {
      if (error) {
        dispatch(setError(""))
      }
    }
  }, [accessToken, error])

  return (
    <>
      <div className="container mb-3 ">
        <Link
          className="d-flex align-items-center reminders-page__link-container"
          to="/welcome"
        >
          <IconArrowLeft />
          <span className="reminders-page__link-text">
            {t("buttons.backNew")}
          </span>
        </Link>
      </div>{" "}
      {status === "PHONE-STEP-TWO" ? (
        <div className="login w-100 p-sm-4 px-2 py-3 mx-auto">
          <button
            className="login-back px-2"
            onClick={() => {
              dispatch(setLoginPhoneStepOne())
            }}
          >
            <BsFillCaretLeftFill size="14px" />
            {t("loginWhatApp.back")}
          </button>

          <div className="login-head">
            <h2 className="login__title w-100 text-center">
              {t("loginWhatApp.titleTwo")}
            </h2>
            <span className="login-desc w-100 text-center text-body-tertiary d-block mt-3">
              {t("loginWhatApp.descTwo")} + {hidePhone(phone)}
            </span>
          </div>
          <LoginWhatsAppStep2 />
        </div>
      ) : (
        <div className=" row w-100 d-flex justify-content-center ">
          {" "}
          <div className="col-12 col-md-6  col-lg-5 ps-3 d-none d-md-block   pe-5 me-md-0 ms-md-0 justify-content-center">
            <div className="d-flex  mb-1 justify-content-start  justify-content-start  m-0 p-0"></div>
            <div
              className="d-flex  mb-1 align-items-center  justify-content-start   m-0 p-0 "
              style={{ minHeight: "300px" }}
            >
              {/* {isLoadingImage && (
                <Skeleton width="350px" height="400px" borderRadius="8px" />
              )} */}
              <img
                src={success}
                // width="100%"
                // height="400px"
                style={{
                  maxHeight: "370px",
                  maxWidth: "370px",
                  objectFit: "contain",
                  // display: isLoadingImage ? "none" : "flex",
                  display: "flex",
                }}
                // onLoad={handleImageLoad}
              />
            </div>{" "}
            <div
              className="mb-1 d-flex flex-column gap-1 align-items-start justify-content-start   m-0 p-0 "
              // style={{ maxWidth: "350px" }}
            >
              <h5 className=" fs-1 text-dark text-capitalize mb-2">
                {t("welcome.welcomeBack")}
              </h5>
              <h5
                className="text-muted fw-bold    mb-2 "
                style={{ color: "#6D717A", fontFamily: "Inter" }}
              >
                {t("welcome.yourSourceForPersonalInvitations")}
              </h5>
              <h5
                className="text-muted  "
                style={{
                  fontFamily: "Inter",
                  color: "#6D717A",
                  fontSize: "1.0rem",
                }}
              >
                {t("welcome.whatWeOffer")}
              </h5>
            </div>
          </div>
          <div className=" col-12 col-md-6  col-lg-6 login   row p-sm-4 px-2 py-3 ">
            <div className=" d-flex flex-column justify-content-center align-items-center">
              <img
                src="/images/whatsapp.jpg"
                width="50px"
                height="50px"
                alt=""
                className="d-flex justify-content-center align-items-center"
              />
              <h3
                className="mt-3 fs-3 text-center fw-normal "
                style={{ color: "#245192" }}
              >
                {t("event.logInUsingWhatsAppNumber")}
              </h3>

              <h6 className="mt-3 fs-9 text-center text-muted opacity-75 fw-light">
                {t("event.weWillSendTheCode")}
              </h6>
            </div>

            <LoginWhatsAppStep1 />
          </div>
        </div>
      )}
    </>
  )
}

export default LoginWhatsAppPage
